import React from 'react';
import { Helmet } from 'react-helmet';

const BASE_URL = 'https://www.thranatech.com';
const SITE_NAME = 'Thranatech.com';

const SEO = ({
  title,
  description,
  path = '/',
  image = `${BASE_URL}/logo192.png`,
  type = 'website',
  robots = 'index,follow',
  structuredData,
}) => {
  const url = `${BASE_URL}${path === '/' ? '' : path}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;

